module.exports = __webpack_public_path__ + "static/media/MHRM39N0015.92a5d38c.svg";